export function initResponsiveSlides(options) {
  const slider = $('#slider1');
  if (!slider.length || typeof slider.responsiveSlides !== 'function') {
    return;
  }

  slider.responsiveSlides({
    auto: !!options.auto,
    pager: true,
    nav: true,
    speed: 1500,
    maxwidth: 940,
    prevText: 'Previous',
    nextText: 'Next',
    namespace: 'centered-btns',
  });
}
